import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import parse from "html-react-parser";
import Page from "../../layouts/Page";
import TextBlock from "../../components/TextBlock";
import styles from "./styles.module.sass";
import { hostname } from "../../constants";

interface Overview {
  content: { rendered: string };
}

interface Room {
  slug: string;
  title: { rendered: string };
  _embedded?: {
    "wp:featuredmedia"?: { source_url: string }[];
  };
}

const AllRooms: React.FC = () => {
  const { country } = useParams<Record<string, string>>();
  const [overview, setOverview] = useState<Overview | null>(null);
  const [rooms, setRooms] = useState<Room[]>([]);

  useEffect(() => {
    if (!country) return;

    fetch(`${hostname}/${country}/wp-json/wp/v2/pages?slug=rooms-overview`)
      .then((res) => res.json())
      .then((data) => setOverview(data[0] || null));

    fetch(`${hostname}/${country}/wp-json/wp/v2/rooms?_embed`)
      .then((res) => res.json())
      .then((data) => setRooms(data));
  }, [country]);

  if (!overview || rooms.length === 0) return null;

  return (
    <Page type="local" className={styles.base} country={country}>
      <TextBlock>
        <div className={styles.intro}>{parse(overview.content.rendered)}</div>
      </TextBlock>
      <ul className={styles.roomList}>
        {rooms.map((room) => (
          <li key={room.slug} className={styles.roomItem}>
            <Link
              to={`${process.env.PUBLIC_URL}/${country}/rest/${room.slug}`}
              className={styles.roomLink}
            >
              {room._embedded?.["wp:featuredmedia"]?.[0]?.source_url && (
                <img
                  src={room._embedded["wp:featuredmedia"]![0].source_url}
                  alt={room.title.rendered}
                />
              )}
              <p className={styles.roomName}>{room.title.rendered}</p>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export default AllRooms;
